import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom';
import { Apirequests } from '../../utils/ApiRequests';
import SpinningLogo from '../../components/Spinner';
import CustomPageHeader from '../../components/CustomPageHeader';
import { downloadExcel } from '../../utils/DownloadXls';
import { ErrorTost, SuccessTost } from '../../utils/ToastHelper';
import Table from '../../components/Table';
import moment from 'moment';
import BtnSpinner from '../../components/BtnSpinner';
import { Trash } from 'lucide-react';
import Pagination from '../../components/Pagination';
import CustomOffCanvas from '../../components/CustomOffCanvas';
import AddQuery from './AddQuery';

function QueryLeads() {

    const [isOffCanvasOpen, setIsOffCanvasOpen] = useState({ state: false, name: "" });
    const [queries, setQueries] = useState(null);
    const [searchTerm, setSearchTerm] = useState('');
    const [loading, setLoading] = useState({ state: false, name: "" });
    const [currentPage, setCurrentPage] = useState(1);
    const [refresh, setRefresh] = useState(false);
    const [currentLead, setCurrentLead] = useState(null);
    const [deleteId, setdeleteId] = useState(null)

    const token = localStorage.getItem("token");

    const totalItems = queries?.length; // Total number of items
    const itemsPerPage = 10;

    const currentData = queries?.slice(
        (currentPage - 1) * itemsPerPage,
        currentPage * itemsPerPage
    );

    const handlePageChange = (newPage) => {
        setCurrentPage(newPage);
    };

    const navigate = useNavigate();

    const handleRefresh = () => setRefresh(!refresh);

    const handleSearch = async () => {
        if (!searchTerm) {
            return ErrorTost("Enter a key to serach")
        }

        if (currentPage !== 1) {
            setCurrentPage(1)
        }

        await getQueries(searchTerm)
    };

    const getQueries = async () => {
        setLoading({ state: true, name: "fetchqueries" });
        try {
            const res = await Apirequests(
                `home/get-queries?q=${searchTerm}`,
                "GET",
                {},
                {
                    Authorization: `Bearer ${token}`,
                }
            );
            // console.log(res, 'fetch chapters res')
            if (res?.success) {
                setQueries(res.data);
            }
        } catch (error) {
            console.log(error, "fetch queries error.");
        }
        setLoading({ state: false, name: "" });
    };

    const handleDeleteQuery = async (id) => {
        setdeleteId(id);
        setLoading({ state: true, name: "deletequery" })
        try {
            const deleteRes = await Apirequests(`home/delete-query/${id}`, 'DELETE', {}, {
                Authorization: `Bearer ${token}`,
            });
            if (deleteRes.success) {
                SuccessTost(deleteRes?.message);
                setRefresh(!refresh)
            } else {
                ErrorTost(deleteRes?.message)
            }
        } catch (error) {
            console.log(error, 'error deleting chapter');
            ErrorTost("Something went wrong, please try again later.")
        }

        setLoading({ state: true, name: "" });
        setdeleteId(null)
    }

    useEffect(() => {
        getQueries();
    }, [refresh, token]);

    if (loading.state && loading.name === "fetchqueries") {
        return <div className='h-screen w-full flex items-center justify-center bg-[rgba(255,255,255,0.5)]'>
            <SpinningLogo />
        </div>
    }


    return (
        <div>
            <CustomPageHeader
                title={`Queries`}
                text={searchTerm}
                setText={setSearchTerm}
                handleSearch={handleSearch}
                onClick={() => setIsOffCanvasOpen({ state: true, name: "addquery" })}
                btnText={"Add Query"}
                handleBackClick={() => navigate("/")}
                handleRefresh={handleRefresh}
                handleDownload={() => downloadExcel(queries, 'queries')}
            />

            <main className="mx-auto py-6 sm:px-6 lg:px-8">
                <div className="px-4 py-6 sm:px-0">
                    <div className="overflow-x-auto">
                        <Table
                            tableHead={

                                <tr>
                                    <th className="px-6 py-3 text-xs font-medium text-gray-500 uppercase tracking-wider">Name</th>
                                    <th className="px-6 py-3 text-xs font-medium text-gray-500 uppercase tracking-wider">Email</th>
                                    <th className="px-6 py-3 text-xs font-medium text-gray-500 uppercase tracking-wider">Whatsapp Number</th>
                                    <th className="px-6 py-3 text-xs font-medium text-gray-500 uppercase tracking-wider">Query</th>
                                    {/* <th className="px-6 py-3 text-xs font-medium text-gray-500 uppercase tracking-wider">Amount</th> */}
                                    <th className="px-6 py-3 text-xs font-medium text-gray-500 uppercase tracking-wider">Crated At</th>
                                    <th className="px-6 py-3 text-xs font-medium text-gray-500 uppercase tracking-wider">Actions</th>
                                </tr>
                            }
                            tableBody={
                                currentData?.map((query, i) =>
                                    <tr key={i}>
                                        {/* <td className="px-6 py-4 whitespace-nowrap"><span className='text-indigo-600 cursor-pointer' onClick={() => { setIsOffCanvasOpen({ state: true, name: 'vieworderdetails' }); setCurrentOrder(order) }}>{order?.order_id || "not available"}</span></td> */}
                                        <td className="px-6 py-4 whitespace-nowrap">{query.name}</td>
                                        <td className="px-6 py-4 whitespace-nowrap">{query?.email}</td>
                                        <td className="px-6 py-4 whitespace-nowrap">{query.whatsapp_number}</td>
                                        <td className="px-6 py-4 whitespace-nowrap">{query?.query}</td>
                                        <td className="px-6 py-4 whitespace-nowrap">{moment(query?.createdAt).format('DD-MM-YY hh:mm a')}</td>
                                        <td className="px-6 py-4 whitespace-nowrap flex gap-3">
                                            <button className='flex bg-red-200 rounded-lg px-3 py-2 items-center gap-1' onClick={() => handleDeleteQuery(query?._id)}>
                                                {
                                                    loading.state && loading.name === "deletequery" && deleteId === query?._id ?
                                                        <BtnSpinner /> :
                                                        <>
                                                            <Trash className='text-red-700 text-sm' size={20} />
                                                            <span className='text-red-700 text-sm'>Delete</span>
                                                        </>
                                                }

                                            </button>

                                            {/* <button className='flex bg-gray-200 rounded-lg px-3 py-2 items-center gap-1' onClick={() => { setIsOffCanvasOpen({ state: true, name: "editorder" }); setCurrentOrder(order) }}><Edit3 size={18} /> Edit</button> */}
                                        </td>
                                    </tr>)
                            }
                        />
                    </div>
                </div>
                {queries?.length ?
                    <div className="flex gap-x-2 items-center justify-between">
                        <p>total: {queries?.length}</p>
                        <Pagination
                            page={currentPage}
                            totalItems={totalItems}
                            itemsPerPage={itemsPerPage}
                            onPageChange={handlePageChange}
                        />
                    </div> : null}
            </main>

            <CustomOffCanvas
                open={isOffCanvasOpen.state && isOffCanvasOpen?.name === "addquery"}
                close={() => { setIsOffCanvasOpen({ state: false, name: "" }); setCurrentLead(null) }}
                content={
                    <AddQuery
                        close={() => { setIsOffCanvasOpen({ state: false, name: "" }); setCurrentLead(null) }}
                        setRefresh={setRefresh}
                    />
                }
            />

        </div>
    )
}

export default QueryLeads